import {
  COURSE_LIST_FAIL,
  COURSE_LIST_REQUEST,
  COURSE_LIST_SUCCESS,
} from "../constants/courseConstants";
import api from "../core/api";

export const CourseList = (FilterData) => async (dispatch) => {
  try {
    dispatch({
      type: COURSE_LIST_REQUEST,
    });

    const { data } = await api.post(`/course`, FilterData);

    var dt = data.Result;

    if (dt?.includes("Error")) {
      dispatch({
        type: COURSE_LIST_FAIL,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: COURSE_LIST_SUCCESS,
        payload: data?.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: COURSE_LIST_FAIL,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
